module.exports = __webpack_public_path__ + "img/otamerica_co_spanish_2023_certification_badge.6c761826.png";